import { useEffect, useState } from "react";
import { Modal, Select, Input, Typography, message, Divider, Tag } from "antd";
import axiosInstance from "../../../../variables/api/axiosInstance";
import { getParametre } from "../../../../hooks/useHooks";
import { TYPE_PARAM_MOTIF_EXCLUSION, ligneIdOf } from "../retrocessionHooks";

const { Text } = Typography;

const TYPE_LABEL = {
    EMISSION: "Émission",
    ANNULATION: "Annulation",
    SINISTRE: "Sinistre payé",
    RECOURS: "Recours",
};

/**
 * Écarter une ligne de la rétrocession (compte de cession corrigé).
 * props : open, onClose, onSaved, context = { type, ligne, compagnieCode, mois }
 */
const MotifExclusionModal = ({ open, onClose, onSaved, context }) => {
    const { type, ligne, compagnieCode, mois } = context || {};
    const [motifs, setMotifs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [motif, setMotif] = useState(undefined);
    const [commentaire, setCommentaire] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open || !type) return;
        setMotif(undefined);
        setCommentaire("");
        setLoading(true);
        getParametre(TYPE_PARAM_MOTIF_EXCLUSION[type])
            .then(({ data }) => setMotifs((data || []).map((p) => p.libelleParametre || p.valeur).filter(Boolean)))
            .catch(() => setMotifs([]))
            .finally(() => setLoading(false));
    }, [open, type]);

    const montant = Number(ligne?.totalRetrocede ?? ligne?.montant ?? 0);

    const enregistrer = () => {
        if (!motif) { message.warning("Sélectionnez un motif."); return; }
        setSaving(true);
        axiosInstance.post(`/api/retrocession/exclusion`, {
            type,
            ligneCodeId: ligneIdOf(ligne),
            compagnieCode: compagnieCode || null,
            moisRetrocession: mois,
            motif,
            commentaire: commentaire || null,
            montant,
        })
            .then(() => { message.success("Ligne écartée de la rétrocession."); onSaved && onSaved(); onClose && onClose(); })
            .catch((e) => message.error(e?.response?.data?.message || "Échec de l'exclusion."))
            .finally(() => setSaving(false));
    };

    return (
        <Modal open={open} onCancel={onClose} onOk={enregistrer} confirmLoading={saving}
            okText="Écarter" okButtonProps={{ danger: true }} cancelText="Annuler"
            title="Écarter cette ligne de la rétrocession" width={540}>
            <div style={{ marginBottom: 10 }}>
                <Tag color="blue">{TYPE_LABEL[type] || type}</Tag>
                <Text strong style={{ marginLeft: 6 }}>{ligne?.numeroPolice || ligne?.sinistreNumSinistre || ligneIdOf(ligne) || "—"}</Text>
                <div><Text type="secondary">Montant : {montant.toLocaleString("fr-FR")} F</Text></div>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    La ligne reste conservée (version compagnie) ; elle ne sera pas rétrocédée (version corrigée).
                </Text>
            </div>
            <Divider style={{ margin: "8px 0" }} />
            <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Motif d'exclusion *</div>
                <Select style={{ width: "100%" }} loading={loading} value={motif} onChange={setMotif}
                    placeholder="Sélectionner un motif" options={motifs.map((m) => ({ value: m, label: m }))}
                    notFoundContent={loading ? "Chargement…" : "Aucun motif paramétré pour ce type"} showSearch optionFilterProp="label" />
            </div>
            <div>
                <div style={{ fontSize: 12, color: "#888", marginBottom: 4 }}>Commentaire (facultatif)</div>
                <Input.TextArea rows={3} value={commentaire} onChange={(e) => setCommentaire(e.target.value)} />
            </div>
        </Modal>
    );
};

export default MotifExclusionModal;
